export enum SubscriptionStatus {
  PendingPayment = 'pending payment',
  PendingChanges = 'pending changes',
  FinalizingInvoice = 'finalizing invoice',
  Active = 'active',
  Trial = 'trial',
  Inactive = 'inactive',
}
